import { useAppConfig } from '#/config/AppConfigContext';
import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import type { searchVolopsRouteReference } from '#/modules/search/routing/search.routes';
import { ClientOnlyLazySearchVolopsRefinements } from '#/modules/search/volops/components/Refinements/ClientOnlyLazySearchVolopsRefinements';
import { searchVolopsRoutePathByLocale } from '#/modules/search/volops/routing/seachVolops.route-paths';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';
import { getStaticImageSrc } from '#/utils/getImageSrc';

import { SearchVolopsPage } from './SearchVolopsPage';

export const handle = {
  urlByLocale: searchVolopsRoutePathByLocale,
  darkBackground: true,
  defaultSearchType: 'VOLOP',
  hideFooterDivider: true,
  showDesktopSearch: true,
  searchFromPageType: 'SEARCH',
  showSearchRefinements: true,
  searchRefinements: (
    <ClientOnlyLazySearchVolopsRefinements includeSourcesFacet={false} />
  ),
  isSearchPage: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof searchVolopsRouteReference>,
) {
  // empty loader
}

export default function SearchVolopsHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { appConfig } = useAppConfig();
  const { i18n, locale } = useI18n();

  const ogImage = (() => {
    switch (locale) {
      case I18nLocale.EN:
        return getStaticImageSrc(
          'og-image-en-volunteer.jpg',
          appConfig.idealist.staticImgPath,
        );
      case I18nLocale.ES:
        return;
      case I18nLocale.PT:
        return getStaticImageSrc(
          'og-image-pt-volunteer.jpg',
          appConfig.idealist.staticImgPath,
        );
    }
  })();

  return (
    <RouteModule
      title={
        /* TRANSLATORS: volop search page title */
        i18n(
          'Best Virtual Volunteer Opportunities, On-Site Volunteering, and More',
        )
      }
      description={
        /* TRANSLATORS: volop search page description */
        i18n(
          'Ready to make a difference? Search for volunteer opportunities at nonprofits and purpose-driven companies',
        )
      }
      ogImage={ogImage}
    >
      <SearchVolopsPage />
    </RouteModule>
  );
}
